/**
 * Pro účely HELPED_FRAGMENTS
 * Když potřebuju vytáhnout data z Fragmentu na který mířím, tak se používá tato funkce
 * Ukázka:
 * formElement.getAttribute(replaceSquareBrackets(HELPED_FRAGMENTS.FORM_EVENT_ID))
 * Vrací: data z elementu -> například: email (element id pro email - #widgetData[email]#)
*/
export const replaceSquareBrackets = fragment => fragment.replace('[', '').replace(']', '');



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/FacebookBusiness/utils/replaceSquareBrackets.js